import { Component, inject, input, signal, ChangeDetectionStrategy } from '@angular/core'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ErrorCenterService } from '../../../services'
import { ErrorCenterComponent } from '../error-center.component'

@Component({
  selector: 'lib-error-center-button',
  imports: [MatBadgeModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './error-center-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './error-center-button.component.scss',
})
export class ErrorCenterButtonComponent {
  private readonly dialog = inject(MatDialog)
  readonly errorCenterService = inject(ErrorCenterService)

  /**
   * Die Fehlerzentrale ist ein SaniUp-internes Werkzeug (roher Stacktrace/JSON) — ohne dieses Flag
   * bleibt der Button verborgen. Die App entscheidet, wer als SaniUp-Mitarbeitende:r gilt.
   */
  readonly saniupEmployee = input(false)

  readonly checkedErrorCounter = signal(0)

  open() {
    this.checkedErrorCounter.set(this.errorCenterService.errors().length)
    this.dialog.open(ErrorCenterComponent, { width: '48rem', maxWidth: '95vw' })
  }
}
